/**
 * Performs a simple client-side email format check.
 * Requires non-whitespace characters before '@', between '@' and '.',
 * and after '.', with no whitespace anywhere in the value.
 * @param email - email string to validate
 */
export function isEmailValid(email: string) {
  return /^\S+@\S+\.\S+$/.test(email)
}
